import '@forest/native-diagnostics'

import { initializeNativeBridge, native } from '@forest/native-services'
import { appVersion, language } from './lib/params'
import { overwriteGetLocale, type Locale } from './paraglide/runtime'

overwriteGetLocale(() => language as Locale)

initializeNativeBridge({
  appVersion: appVersion ?? '0.0.0',
  bifrost: { enableDebug: import.meta.env.MODE !== 'production' },
})

void native.general.logEvent({
  event_name: 'page_view',
  event_params: { page_name: 'c2c_referral' },
})
void native.general.pageReady()
